<script lang="ts">
    import HomeIntro from 'src/components/main/home/components/home-intro/HomeIntro.svelte'
    import VisitCommunity from 'src/components/main/#common/visit-community/VisitCommunity.svelte'
    import MainLayout from '../#common/layout/Layout.svelte'
    import GameCards from 'src/components/main/home/components/game-cards/GameCards.svelte'
    import HomeHero from 'src/components/main/home/components/home-hero/HomeHero.svelte'
    import HomeElements from 'src/components/main/home/components/home-elements/HomeElements.svelte'
    import Blog from 'src/components/main/home/components/blog/Blog.svelte'
</script>

<svelte:head>
    <title>Elemental Games</title>
    <meta name="description" content=""/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <HomeIntro/>
        <GameCards/>
        <HomeHero/>
        <HomeElements/>
<!--        <VisitCommunity/>-->
<!--        <Blog/>-->
    </svelte:fragment>
</MainLayout>
